import React from "react";
import { Flex as RFlex } from "rebass/styled-components";
import BaseComponent from "../Base/BaseComponent";
import LogEvent from "../../log/LogEvent";

const Flex = (props) => {
  return (
    <LogEvent logEventProps={props.logEventProps} actionProps={{ onClick: { action: "click" } }} elementType="flex">
      <BaseComponent data-testid={props.testid} {...props} as={RFlex} />
    </LogEvent>
  );
};

export default Flex;
